// import React, { useEffect, useState } from "react";
// import {
//   LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid,
//   BarChart, Bar, PieChart, Pie, Cell, Legend,
//   ResponsiveContainer
// } from "recharts";

// import "../css/ControlTower.css";

// const API = "https://api.mahal.qa/api/v1/admin/dashboard-metrics";

// const COLORS = {
//   Pending: "color-pending",
//   Completed: "color-completed",
//   Failed: "color-failed"
// };

// const formatCurrency = (val) =>
//   `QAR ${Number(val || 0).toLocaleString("en-QA")}`;

// const formatPercent = (val) =>
//   `${Number(val || 0).toFixed(1)}%`;

// const KpiCard = ({ title, value, highlight }) => (
//   <div className={`kpi-card ${highlight || ""}`}>
//     <div className="kpi-title">{title}</div>
//     <div className="kpi-value">{value}</div>
//   </div>
// );

// const normalizeStatusData = (data = []) => {
//   const map = {};
//   data.forEach((item) => {
//     const key = item.status;
//     if (!map[key]) map[key] = 0;
//     map[key] += Number(item.total || 0);
//   });

//   return Object.keys(map).map((k) => ({
//     status: k,
//     total: map[k]
//   }));
// };

// export default function ControlTower() {

//   const [data, setData] = useState(null);
//   const [range, setRange] = useState("7d");
//   const token = localStorage.getItem("admin_token");

//   const fetchData = () => {
//     fetch(`${API}?range=${range}`, {
//       headers: { Authorization: `Bearer ${token}` }
//     })
//       .then(res => res.json())
//       .then(setData)
//       .catch(console.error);
//   };

//   useEffect(() => { fetchData(); }, [range]);

//   useEffect(() => {
//     const interval = setInterval(fetchData, 30000);
//     return () => clearInterval(interval);
//   }, [range]);

//   if (!data) return <div>Loading dashboard...</div>;

//   const {
//     kpis,
//     order_trend,
//     revenue_trend,
//     order_status_distribution,
//     top_suppliers,
//     alerts,
//     recent_activity,
//     extra
//   } = data;

//   const pieData = normalizeStatusData(order_status_distribution);
//   return (
//     <div className="droid-container">
//       <div className="page-center ">
//         <div className="page-content ">
//           <div className="ct-container">

//             {/* ===== HEADER ===== */}
//             <div className="droid-header">
//               <div>
//                 <h2>📊 Control Tower</h2>
//                 <p>Real-time platform insights & monitoring</p>
//               </div>

//               <div className="header-actions">
//                 <button onClick={() => setRange("today")}>Today</button>
//                 <button onClick={() => setRange("7d")}>7 Days</button>
//                 <button onClick={() => setRange("month")}>Month</button>
//               </div>
//             </div>

//             {/* ===== KPI ===== */}
//             <div className="droid-kpis">
//               <KpiCard title="Today Orders" value={kpis.today_orders} />
//               <KpiCard title="Pending Orders" value={kpis.pending_orders} />
//               <KpiCard title="Active Suppliers" value={kpis.active_suppliers} />
//               <KpiCard title="Active Restaurants" value={kpis.active_restaurants} />
//             </div>

//             {/* ===== MAIN GRID ===== */}
//             <div className="droid-main">

//               {/* ===== LEFT SIDE ===== */}
//               <div className="droid-left">

//                 {/* BIG CHART ONLY */}
//                 <div className="ct-card big">
//                   <h4>Orders Trend</h4>
//                   <ResponsiveContainer width="100%" height={280}>
//                     <LineChart data={order_trend}>
//                       <CartesianGrid strokeDasharray="3 3" />
//                       <XAxis dataKey="day" />
//                       <YAxis />
//                       <Tooltip />
//                       <Line type="monotone" dataKey="total" stroke="#6c63ff" strokeWidth={2} />
//                     </LineChart>
//                   </ResponsiveContainer>
//                 </div>

//                 {/* TABLE MOVED HERE */}
//                 <div className="ct-card">
//                   <h4>Recent Activity</h4>
//                   <table className="table">
//                     <thead>
//                       <tr>
//                         <th>Order</th>
//                         <th>Status</th>
//                         <th>Date</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {recent_activity.map((a, i) => (
//                         <tr key={i}>
//                           <td>{a.order_id}</td>
//                           <td>{a.status}</td>
//                           <td>{new Date(a.order_date).toLocaleString()}</td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>

//               </div>

//               {/* ===== RIGHT SIDE ===== */}
//               <div className="droid-right">

//                 {/* MOVED Revenue HERE */}
//                 <div className="ct-card">
//                   <h4>Revenue Trend</h4>
//                   <ResponsiveContainer width="100%" height={200}>
//                     <BarChart data={revenue_trend}>
//                       <XAxis dataKey="day" />
//                       <YAxis />
//                       <Tooltip formatter={(val) => formatCurrency(val)} />
//                       <Bar dataKey="total" fill="#22c55e" />
//                     </BarChart>
//                   </ResponsiveContainer>
//                 </div>

//                 <div className="ct-card">
//                   <h4>Order Status</h4>
//                   <ResponsiveContainer width="100%" height={200}>
//                     <PieChart>
//                       <Pie data={pieData} dataKey="total" outerRadius={70}>
//                         {pieData.map((entry, i) => (
//                           <Cell key={i} className={COLORS[entry.status]} />
//                         ))}
//                       </Pie>
//                       <Tooltip />
//                     </PieChart>
//                   </ResponsiveContainer>
//                 </div>

//                 <div className="ct-card">
//                   <h4>Top Suppliers</h4>
//                   <ResponsiveContainer width="100%" height={200}>
//                     <BarChart data={top_suppliers}>
//                       <XAxis dataKey="supplier_id" />
//                       <YAxis />
//                       <Tooltip />
//                       <Bar dataKey="total_orders" fill="#8b5cf6" />
//                     </BarChart>
//                   </ResponsiveContainer>
//                 </div>

//                 {/* MOVED FINANCIAL HERE */}
//                 <div className="ct-card">
//                   <h4>Financial & Health</h4>
//                   <div className="kpi-financial-grid">
//                     <KpiCard title="Credit Given" value={formatCurrency(kpis.credit_given)} />
//                     <KpiCard title="Credit Collected" value={formatCurrency(kpis.credit_collected)} />
//                     <KpiCard title="Outstanding Credit" value={formatCurrency(kpis.outstanding_credit)} />
//                     <KpiCard title="Overdue Credit" value={formatCurrency(kpis.overdue_credit)} />
//                     <KpiCard title="Avg Order Value" value={formatCurrency(kpis.avg_order_value)} />
//                     <KpiCard title="Success Rate" value={formatPercent(kpis.success_rate)} />
//                     <KpiCard title="Cancellation Rate" value={formatPercent(kpis.cancellation_rate)} />
//                   </div>
//                 </div>

//                 <div className="ct-alert-card">
//                   <h4>🚨 Needs Attention</h4>
//                   <div className="alert-grid">
//                     <div>⚠ Stuck Orders: {alerts.stuck_orders}</div>
//                     <div>❌ Failed Payments: {alerts.failed_payments}</div>
//                     <div>🕒 Pending Suppliers: {alerts.pending_suppliers}</div>
//                     <div>🔥 High Priority Tickets: {alerts.high_priority_tickets}</div>
//                     <div>⏱ SLA Breach: {alerts.sla_breach}</div>
//                     <div>💰 Overdue Credit: {formatCurrency(alerts.overdue_credit)}</div>
//                   </div>
//                 </div>

//                 <div className="ct-card">
//                   <h4>⚡ System Insights</h4>
//                   <div>⚠ Credit Risk Restaurants: {kpis.credit_risk_restaurants}</div>
//                   <div>🚫 Inactive Suppliers: {extra?.inactive_suppliers}</div>
//                 </div>

//               </div>

//             </div>

//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }



import React, { useEffect, useState } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  BarChart,
  Bar,
  PieChart,
  Pie,
  Cell,
  Legend,
  ResponsiveContainer
} from "recharts";

const API = "https://api.mahal.qa/api/v1/admin/dashboard-metrics";

const COLORS = {
  Pending: "#ff9800",
  Completed: "#4caf50",
  Failed: "#f44336"
};

/* ================= FORMATTERS ================= */

const formatCurrency = (val) =>
  `QAR ${Number(val || 0).toLocaleString("en-QA")}`;

const formatPercent = (val) =>
  `${Number(val || 0).toFixed(1)}%`;

/* ================= KPI CARD ================= */

const KpiCard = ({ title, value, icon, color }) => (
  <div className="stat_card">

    <div className={`stat_icon ${color}`}>
      <i className={icon}></i>
    </div>

    <div className="stat_content">
      <h3>{value}</h3>
      <p>{title}</p>
    </div>

  </div>
);

/* ================= SAFE NORMALIZER ================= */

const normalizeStatusData = (data = []) => {
  const map = {};

  data.forEach((item) => {
    const key = item.status;

    if (!map[key]) map[key] = 0;

    map[key] += Number(item.total || 0);
  });

  return Object.keys(map).map((k) => ({
    status: k,
    total: map[k]
  }));
};

/* ================= BLINK STYLE ================= */

const blinkStyle = {
  animation: "blink 1s infinite",
  color: "red",
  fontWeight: "bold"
};

/* ================= MAIN ================= */

export default function ControlTower() {

  const [data, setData] = useState(null);
  const [range, setRange] = useState("7d");

  const token = localStorage.getItem("admin_token");

  const fetchData = () => {
    fetch(`${API}?range=${range}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then((res) => res.json())
      .then(setData)
      .catch(console.error);
  };

  useEffect(() => {
    fetchData();
  }, [range]);

  useEffect(() => {
    const interval = setInterval(fetchData, 30000);

    return () => clearInterval(interval);
  }, [range]);

  if (!data) {
    return <div>Loading dashboard...</div>;
  }

  const {
    kpis,
    order_trend,
    revenue_trend,
    order_status_distribution,
    top_suppliers,
    alerts,
    recent_activity,
    extra
  } = data;

  const pieData = normalizeStatusData(order_status_distribution);

  return (
    <div className="admin-dashboard">



      {/* ================= KPI ================= */}


      <div className="dashboard_page">
        <div className="page_header">
          <h2>Control Tower</h2>
          <p>Welcome back! Here’s today’s restaurant summary</p>
        </div>
        <div className="row mt-3">

          {/* TODAY ORDERS */}
          <div className="col-lg-3 col-md-6 mb-3">
            <div className="stat_card credit_card" id="tour-credit-limit">

              <div className="stat_icon blue">
                <i className="fas fa-shopping-bag"></i>
              </div>

              <div className="stat_content">
                <h3>{kpis.today_orders || 0}</h3>

              </div>
              <p>Today Orders</p>
            </div>
          </div>

          {/* PENDING ORDERS */}
          <div className="col-lg-3 col-md-6 mb-3">
            <div className="stat_card credit_card_used" id="tour-used-credit">

              <div className="stat_icon orange">
                <i className="fas fa-clock"></i>
              </div>

              <div className="stat_content">
                <h3>{kpis.pending_orders || 0}</h3>

              </div>
              <p>Pending Orders</p>
            </div>
          </div>
          {/* FAILED ORDERS */}
          <div className="col-lg-3 col-md-6 mb-3">
            <div className="stat_card credit_card_due" id="tour-due-date">

              <div className="stat_icon orange">
                <i className="fas fa-clock"></i>
              </div>

              <div className="stat_content">
                <h3>{kpis.failed_orders || 0}</h3>

              </div>
              <p>Failed Orders</p>
            </div>
          </div>

          {/* ACTIVE SUPPLIERS */}
          <div className="col-lg-3 col-md-6 mb-3">
            <div className="stat_card credit_card_available" id="tour-available">

              <div className="stat_icon green">
                <i className="fas fa-truck"></i>
              </div>

              <div className="stat_content">
                <h3>{kpis.active_suppliers || 0}</h3>

              </div>
              <p>Active Suppliers</p>
            </div>
          </div>

          {/* ACTIVE RESTAURANTS */}
          <div className="col-lg-3 col-md-6 mb-3">
            <div className="stat_card credit_card_due" id="tour-due-date">

              <div className="stat_icon red">
                <i className="fas fa-store"></i>
              </div>

              <div className="stat_content">
                <h3>{kpis.active_restaurants || 0}</h3>

              </div>
              <p>Active Restaurants</p>
            </div>
          </div>
          {/* Today Revenue */}
          <div className="col-lg-3 col-md-6 mb-3">
            <div className="stat_card credit_card_available" id="tour-available">

              <div className="stat_icon red">
                <i className="fas fa-store"></i>
              </div>

              <div className="stat_content">
                <h3>{kpis.today_revenue || 0}</h3>

              </div>
              <p>Today Revenue</p>
            </div>
          </div>

          {/* monthly_revenue */}
          <div className="col-lg-3 col-md-6 mb-3">
            <div className="stat_card credit_card" id="tour-due-date">

              <div className="stat_icon red">
                <i className="fas fa-store"></i>
              </div>

              <div className="stat_content">
                <h3>{kpis.monthly_revenue}</h3>

              </div>
              <p>Monthly Revenue</p>
            </div>
          </div>

          {/* open_tickets  */}
          <div className="col-lg-3 col-md-6 mb-3">
            <div className="stat_card credit_card_used" id="tour-used-credit">

              <div className="stat_icon red">
                <i className="fas fa-store"></i>
              </div>

              <div className="stat_content">
                <h3>{kpis.open_tickets || 0}</h3>

              </div>
              <p>Open Tickets</p>
            </div>
          </div>

        </div>
      </div>

      {/* ================= FINANCIAL ================= */}

      <div className="row mt-4">

        <h3>💰 Financial & Health</h3>

        <div className="col-lg-12 fanancial">

          <KpiCard
            title="Credit Given"
            value={formatCurrency(kpis.credit_given)}
            icon="fas fa-money-bill-wave"
            color="green"
          />

          <KpiCard
            title="Credit Collected"
            value={formatCurrency(kpis.credit_collected)}
            icon="fas fa-hand-holding-usd"
            color="blue"
          />

          <KpiCard
            title="Outstanding Credit"
            value={formatCurrency(kpis.outstanding_credit)}
            icon="fas fa-exclamation-circle"
            color="red"
          />

          <KpiCard
            title="Overdue Credit"
            value={formatCurrency(kpis.overdue_credit)}
            icon="fas fa-calendar-times"
            color="orange"
          />

          <KpiCard
            title="Avg Order Value"
            value={formatCurrency(kpis.avg_order_value)}
            icon="fas fa-chart-line"
            color="blue"
          />

          <KpiCard
            title="Success Rate"
            value={formatPercent(kpis.success_rate)}
            icon="fas fa-check-circle"
            color="green"
          />

        </div>

      </div>

      <div className="cards">
        {/* ================= EXTRA INSIGHTS ================= */}
        <div className="card extra">
          <h4>⚡ System Insights</h4>
          <div>⚠️ Credit Risk Restaurants: {kpis.credit_risk_restaurants}</div>
          <div>🚫 Inactive Suppliers: {extra?.inactive_suppliers}</div>
        </div>

        {/* ================= ALERTS ================= */}

        <div className="card extra">

          <h4>🚨 Needs Attention</h4>

          <div
            style={{
              display: "grid",
              gridTemplateColumns:
                "repeat(auto-fit, minmax(200px,1fr))",
              gap: 10
            }}
          >

            <div
              style={
                alerts.stuck_orders > 0
                  ? blinkStyle
                  : {}
              }
            >
              ⚠ Stuck Orders: {alerts.stuck_orders}
            </div>

            <div>
              ❌ Failed Payments:
              {alerts.failed_payments}
            </div>

            <div>
              🕒 Pending Suppliers:
              {alerts.pending_suppliers}
            </div>

            <div>
              🔥 High Priority Tickets:
              {alerts.high_priority_tickets}
            </div>

            <div
              style={
                alerts.sla_breach > 0
                  ? blinkStyle
                  : {}
              }
            >
              ⏱ SLA Breach:
              {alerts.sla_breach}
            </div>

            <div>
              💰 Overdue Credit:
              {formatCurrency(alerts.overdue_credit)}
            </div>

          </div>
        </div>
      </div>

      {/* ================= CHARTS ================= */}

      <div className="row mt-4">

        {/* ORDER TREND */}
        <div className="col-lg-6 mb-4">

          <div className="card" id="tour-monthly-spent">

            <div className="card-header">
              <h5>Orders Trend</h5>
            </div>

            <div className="card-body">

              <ResponsiveContainer width="100%" height={250}>

                <LineChart data={order_trend}>

                  <CartesianGrid strokeDasharray="3 3" />

                  <XAxis dataKey="day" />

                  <YAxis />

                  <Tooltip />

                  <Line
                    type="monotone"
                    dataKey="total"
                    stroke="#ff9800"
                    strokeWidth={2}
                  />

                </LineChart>

              </ResponsiveContainer>

            </div>

          </div>

        </div>

        {/* REVENUE TREND */}
        <div className="col-lg-6 mb-4">

          <div className="card" id="tour-Orders-overview">

            <div className="card-header">
              <h5>Revenue Trend</h5>
            </div>

            <div className="card-body">

              <ResponsiveContainer width="100%" height={250}>

                <BarChart data={revenue_trend}>

                  <CartesianGrid strokeDasharray="3 3" />

                  <XAxis dataKey="day" />

                  <YAxis />

                  <Tooltip
                    formatter={(val) =>
                      formatCurrency(val)
                    }
                  />

                  <Bar
                    dataKey="total"
                    fill="#4caf50"
                  />

                </BarChart>

              </ResponsiveContainer>

            </div>

          </div>

        </div>

        {/* ORDER STATUS */}
        <div className="col-lg-6 mb-4">

          <div className="card" id="tour-Top-suppliers">

            <div className="card-header">
              <h5>Order Status</h5>
            </div>

            <div className="card-body">

              <ResponsiveContainer width="100%" height={250}>

                <PieChart>

                  <Pie
                    data={pieData}
                    dataKey="total"
                    nameKey="status"
                    outerRadius={90}
                  >

                    {pieData.map((entry, i) => (
                      <Cell
                        key={i}
                        fill={
                          COLORS[entry.status] || "#999"
                        }
                      />
                    ))}

                  </Pie>

                  <Tooltip />

                  <Legend />

                </PieChart>

              </ResponsiveContainer>

            </div>

          </div>

        </div>

        {/* TOP SUPPLIERS */}
        <div className="col-lg-6 mb-4">

          <div className="card" id="tour-Order-status">

            <div className="card-header">
              <h5>Top Suppliers</h5>
            </div>

            <div className="card-body">

              <ResponsiveContainer width="100%" height={250}>

                <BarChart data={top_suppliers}>

                  <XAxis dataKey="supplier_id" />

                  <YAxis />

                  <Tooltip />

                  <Bar
                    dataKey="total_orders"
                    fill="#2196f3"
                  />

                </BarChart>

              </ResponsiveContainer>

            </div>

          </div>

        </div>

      </div>


      {/* ================= ACTIVITY ================= */}
      <div className="card mt-4">
        <div className="card-header">
          <h5>Recent Activity</h5>
        </div>

        <div className="table-responsive">
          <table className="table table-hover mb-0">
            <thead>
              <tr>
                <th>Order ID</th>
                <th>Amount</th>
                <th>Date</th>
                <th>Status</th>
              </tr>
            </thead>

            <tbody>
              {recent_activity?.length === 0 && (
                <tr>
                  <td colSpan="4" id="Activity">
                    No Recent Activity
                  </td>
                </tr>
              )}

              {recent_activity?.map((a, i) => (
                <tr key={i}>
                  <td
                    dir="ltr"
                    id="Activity1"
                  >
                    {a.order_id}
                  </td>

                  <td
                    dir="ltr"
                    id="Activity1"
                  >
                    {formatCurrency(a.total_amount || a.amount || 0)}
                  </td>

                  <td>
                    {new Date(a.order_date).toLocaleString()}
                  </td>

                  <td>
                    <span
                      className={`badge status ${a.status === "DELIVERED"
                        ? "bg-success"
                        : a.status === "CANCELLED"
                          ? "bg-danger"
                          : "bg-warning"
                        }`}
                    >
                      {a.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>





    </div>
  );
}